import { useMutation } from "@tanstack/react-query";
import { applyPromoCode } from "@src/entities/tariffs/api/request/applyPromoCode";
import { useNotificationStore } from "@src/shared/components/Notification";
import { ApplyPromoCodeRequest } from "@src/entities/tariffs/api/interfaces/applyPromoCode";
import { AxiosError } from "axios";

export const useApplyPromoCode = () => {
  const { showAlert } = useNotificationStore();

  return useMutation({
    mutationFn: (params: ApplyPromoCodeRequest) => applyPromoCode(params),
    onError: (error: AxiosError) => {
      console.log(error);
      const response = error?.response?.data as {
        detail: string;
      };
      showAlert(response?.detail, "error");
    },
  });
};
